const doneServicesOutput = {
  title: `Serviços concluídos`,
};

export default doneServicesOutput;
